module.exports = __webpack_public_path__ + "static/media/16.9bd56758.jpg";